import { useContext } from 'react'

import { ParametrizationSupplyContext } from '@provider/Parametrization/SupplyProvider'

import type { IParametrizationSupplyContext } from '@base/@types/providers/Parametrization/SupplyProvider'

export default function useParametrizationPurchase(): IParametrizationSupplyContext {
  const context = useContext(ParametrizationSupplyContext)

  return context
}
